<template>
  <v-card outlined elevation="0" class="rounded-lg ma-4">
    <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
      <v-card-title class="pa-2 card-title-height">
        <v-btn icon elevation="0" class="" @click="showCard = !showCard">
          <v-icon color="white">
            {{
              showCard ? "mdi-chevron-up" : "mdi-chevron-down"
            }}
          </v-icon>
        </v-btn>
        <div class="text-body-1 ml-2 white--text">
          Contacts en cas d'urgence
        </div>
        <v-spacer />
        <div v-if="!disabled">
          <v-btn v-if="!isEditing" color="white" icon @click="editMode()">
            <v-icon> mdi-pencil </v-icon>
          </v-btn>
          <v-btn v-else icon color="white" @click="viewMode()">
            <v-icon> mdi-eye </v-icon>
          </v-btn>
          <v-btn v-if="!reachedMaxEmergencyContacts && !isEditing" color="white" icon @click="addEmergencyContact()">
            <v-icon> mdi-plus </v-icon>
          </v-btn>
        </div>
      </v-card-title>
    </v-sheet>
    <v-expand-transition>
      <div v-if="loading">
        <v-progress-linear indeterminate color="primary" />
        <v-skeleton-loader class="mb-4" type="list-item-three-line" />
        <v-skeleton-loader class="mb-4" type="table-heading, table:  button" />
      </div>
      <div v-else v-show="showCard">
        <div>
          <v-carousel v-if="!isEditing"
            :continuous="false"
            v-model="carouselModel"
            class="grey lighten-4"
            height="auto"
            hide-delimiters
          >
            <v-carousel-item
              v-for="(_, i) in editableContent.emergency_contacts"
              :key="i"
            >
              <v-card-text class="d-flex flex-wrap grey lighten-4">
                <EmergencyContactsViewer
                  :key="`viewEmergencyContatctFormForm-${i}`"
                  :ref="`viewEmergencyContatctFormForm-${i}`"
                  :index="i"
                  :content="content"
                  :content-altered-values="contentAlteredValues"
                />
              </v-card-text>
            </v-carousel-item>
            <template v-slot:prev="{ on, attrs }">
              <v-btn
                v-if="!isEditing"
                v-bind="attrs"
                v-on="on"
                icon
                color="black"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <template v-slot:next="{ on, attrs }">
              <v-btn
                v-if="!isEditing"
                v-bind="attrs"
                v-on="on"
                icon
                color="black"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </v-carousel>
           
          <!-- Emergency Contact Form - Outside Carousel -->
          <div v-if="isEditing && contactEditing !== null">
            <v-card-text class="d-flex flex-wrap grey lighten-4">
              <EmergencyContactsForm
                :key="`editEmergencyContactForm`"
                :ref="`editEmergencyContactForm`"
                :index="contactEditing"
                :content="editableContent"
                :valid.sync="valid"
              />
            </v-card-text>
            <v-divider />
            <v-card-text class="d-flex justify-end">
              <v-btn v-if="!reachedMinEmergencyContacts && !isNewContact" class="white--text ml-4" color="red" @click="deleteEmergencyContact()">
                <v-icon class="mr-3">mdi-trash-can-outline</v-icon>
                Supprimer
              </v-btn>
              <v-btn color="info" class="ml-2 px-4" @click="viewMode()">
                <v-icon class="mr-3">mdi-broom</v-icon>
                Annuler
              </v-btn>
              <v-btn :disabled="loading" color="secondary" elevation="0" class="mx-2 px-4" @click="saveEmergencyContactCustomer()">
                <v-icon class="mr-3">mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </div>
        </div>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import EmergencyContactsForm from '@/components/forms/EmergencyContactsForm';
import EmergencyContactsViewer from '@/components/profile/EmergencyContactsViewer';

import { EventBus } from '../../mixins';

export default {
  name: 'EmergencyContactsCard',
  components: { EmergencyContactsForm, EmergencyContactsViewer },
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    successes: {
      type: Array,
      default: () => []
    },
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showCard: true,
      isEditing: false,
      contactEditing: null,
      loading: false,
      editableContent: JSON.parse(JSON.stringify(this.content)),
      carouselModel: 0,
      valid: false,
      maxEmergencyContacts: 1,
      minEmergencyContacts: 1,
    };
  },
  computed: {
    reachedMaxEmergencyContacts () {
      return this.content.emergency_contacts.length >= this.maxEmergencyContacts;
    },
    reachedMinEmergencyContacts () {
      return this.content.emergency_contacts.length <= this.minEmergencyContacts;
    },
    isNewContact () {
       return this.editableContent.emergency_contacts.length > this.content.emergency_contacts.length;
     }
   },
  methods: {
    editMode () {
      EventBus.$emit('change-errors', []);
      EventBus.$emit('change-successes', []);

      if (!this.editableContent.emergency_contacts) this.editableContent.emergency_contacts = [];

      this.isEditing = true;
      this.contactEditing = this.carouselModel;
    },
    viewMode () {
      // If the user has added a new emergency contact, we need to remove it from the editableContent
      if (this.editableContent.emergency_contacts.length > this.content.emergency_contacts.length) {
        this.editableContent.emergency_contacts.pop();
      }

      EventBus.$emit('change-errors', []);

      this.isEditing = false;
      this.contactEditing = null;
    },
    async deleteEmergencyContact () {
      const index = this.carouselModel;
      this.loading = true;
      this.editableContent.emergency_contacts.splice(index, 1);
      
      const success = await this.saveEditedEmergencyContact(this.editableContent);

      if (success) {
        this.carouselModel = 0;
      }
    },
    async saveEditedEmergencyContact (newEmergencyContact) {
      // If is new contact
      if (this.editableContent.emergency_contacts.length > this.content.emergency_contacts.length) {
        this.carouselModel = this.editableContent.emergency_contacts.length - 1;
      }
      
      const success = await this.saveCustomer(newEmergencyContact);

      this.loading = false;

      this.identifiersLoading = false;
      if (success) {
        this.viewMode();
      }

      this.editableContent = JSON.parse(JSON.stringify(this.content));

      return success
    },
    async saveEmergencyContactCustomer () {
      await this.$refs[`editEmergencyContactForm`].validate();

      if (this.valid) {
        this.loading = true;
        await this.saveEditedEmergencyContact(this.editableContent);
      } else {
        EventBus.$emit('change-errors', ['Erreur dans un des champs du formulaire']);
      }
    },
    addEmergencyContact () {
      this.editableContent.emergency_contacts.push({});
      this.isEditing = true;
      this.contactEditing = this.editableContent.emergency_contacts.length - 1;
    }
  }
};

</script>

<style>
  .v-window__prev,
  .v-window__next {
    background-color: transparent;
  }
  
  .v-window__prev {
    left: -10px !important;
  }
  
  .v-window__next {
    right: -10px !important;
  }

</style>
